import { useEffect, useState } from 'react';
import { Layout } from '../components/layout/Layout';
import { Header } from '../components/layout/Header';
import { CostTable } from '../components/dashboard/CostTable';
import { getCostsSummary } from '../lib/api';
import { Skeleton } from '../components/ui/skeleton';
import { toast } from 'sonner';

export const CostsPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCostsSummary();
        setData(response.data);
      } catch (error) {
        toast.error('Erreur lors du chargement des données');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Layout>
        <Header title="Coûts par période" subtitle="Chargement des données..." />
        <Skeleton className="h-[600px]" />
      </Layout>
    );
  }

  return (
    <Layout>
      <Header
        title="Coûts par période"
        subtitle={`Dernière mise à jour: ${new Date(data?.last_updated).toLocaleString('fr-FR')}`}
      />
      <CostTable data={data} />
    </Layout>
  );
};
